export default __webpack_public_path__ + "static/media/933.ebbec0e3.png";